import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// Function to format numbers as prices
export function formatPrice(
	price: number | string,
	options: Intl.NumberFormatOptions = {},
) {
	const numericPrice = typeof price === "string" ? parseFloat(price) : price;

	const defaultOptions: Intl.NumberFormatOptions = {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 2,
		maximumFractionDigits: 8,
	};

	return new Intl.NumberFormat("en-US", {
		...defaultOptions,
		...options,
	}).format(numericPrice);
}

// Function to format numbers as percentages
export function formatPercentage(
	value: number,
	options: Intl.NumberFormatOptions = {},
) {
	const defaultOptions: Intl.NumberFormatOptions = {
		style: "percent",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	};
	return new Intl.NumberFormat("en-US", {
		...defaultOptions,
		...options,
	}).format(value);
}
